import { useMemo, useState, useSyncExternalStore } from "react";
import { captureSession, getSessionBoundary, onSessionBoundaryChange } from "./session";

/** 同归属复核可获得新授权；仍挂载的旧归属组件始终持有失效授权。 */
export function useSessionLease() {
  const [initial] = useState(captureSession);
  const generation = useSyncExternalStore(onSessionBoundaryChange, () => getSessionBoundary().generation);
  return useMemo(() => {
    const current = captureSession();
    return current.generation === generation && current.ownerGeneration === initial.ownerGeneration ? current : initial;
  }, [generation, initial]);
}
